<template>
  <label class="flex items-center cursor-pointer" :for="name" @click="emit()">
    <input type="hidden" :value="modelValue" :name="name"/>
      <img :src="comp" class="mr-4 w-8 h-8"/>
      {{label}}
  </label>
</template>

<script>
export default {
  name: 'Checkbox',
  emits: ['update:model-value'],
  props: {
    name: {
      type: String
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    label: {
      type: String
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    }
  },
  computed: {
    comp () {
      return this.modelValue === this.trueValue
        ? new URL('/src/assets/check-true.svg?url', import.meta.url).href
        : new URL('/src/assets/check-false.svg?url', import.meta.url).href
    },
    externalValue () {
      if (this.modelValue === true) {
        return this.trueValue
      } else {
        return this.falseValue
      }
    }
  },
  methods: {
    emit () {
      const externalValue = this.modelValue === this.trueValue ? this.falseValue : this.trueValue
      this.$emit('update:model-value', externalValue)
    }
  }
}
</script>

<style scoped>

</style>
